import { useUploadStore } from '../../../store/uploadStore';

export const hasActiveUploads = () => {
  const hasQueuedFiles = Object.values(useUploadStore.getState().uploads).some(({ queue }) => queue.length > 0);
  const hasRegistrationRequests = Object.values(useUploadStore.getState().registrationRequests).some(
    (value) => value.size,
  );

  return hasQueuedFiles || hasRegistrationRequests;
};
